import { ApplicationView } from '@aha-app/mvc';
import React from 'react';
import customElementBoolAttr from '../../../utils/customElementBoolAttr';
import fistToFiveIcons from './fistToFiveIcons';
import styles from './VotingSession.module.css';
import classNames from 'classnames';
import type VotingSessionWidget from '../../../widgets/VotingSessionWidget';

const FistToFiveVoteControl: React.FC<{
  widget: VotingSessionWidget;
  value: number | null;
  onChange: (value: number) => void;
}> = ({ widget, onChange, value }) => {
  if (!widget) return null;

  return (
    <div className='flex-row gap-1 flex-row--justify-center'>
      {[0, 1, 2, 3, 4, 5].map(optionValue => (
        <React.Fragment key={optionValue}>
          <aha-button
            kind='ghost'
            class={classNames(
              styles.votingSquareButton,
              styles.votingSquareButtonLarge
            )}
            active={customElementBoolAttr(value === optionValue)}
            onClick={() => onChange(optionValue)}
          >
            {fistToFiveIcons[optionValue]}
          </aha-button>
          <aha-tooltip>{optionValue} out of 5</aha-tooltip>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ApplicationView(FistToFiveVoteControl);
